<template>

	<div class="c-quote-block c-quote-block--brand" :class="{'c-quote-block--image' : hasImage }">
		<div class="c-quote-block__image" v-if="hasImage && !flip">
			<div class="o-image" style="padding-top:100%;">
				<img class="o-image__full"
				:src="item.images.thumbnail.url"
				v-images-loaded.on.done="imageLoaded"
				v-bind:class="{ isLoaded: loaded }"/>
				<div class="o-image__preview" v-bind:style="{backgroundImage : 'url('+ this.item.images.preview.url +')'}"></div>
			</div>
		</div>
		<blockquote class="c-quote-block__content">
			<span class="c-quote-block__rating" v-if="item.rating">
				<template v-for="n in parseInt(item.rating)">★</template>
			</span>
			<p class="h-text--uppercase h-margin-bottom--none">{{item.quote}}</p>
			<cite>{{item.citation}}</cite>
		</blockquote>
		<div class="c-quote-block__image" v-if="hasImage && flip">
			<div class="o-image" style="padding-top:100%;">
				<img class="o-image__full"
				:src="item.images.thumbnail.url"
				v-images-loaded.on.done="imageLoaded"
				v-bind:class="{ isLoaded: loaded }"/>
				<div class="o-image__preview" v-bind:style="{backgroundImage : 'url('+ this.item.images.preview.url +')'}"></div>
			</div>
		</div>
	</div>

</template>

<script>
	import imagesLoaded from 'vue-images-loaded'

  export default {
		name: 'quote-block',
		directives: {
			imagesLoaded
		},
		data: function () {
			return {
				loaded : false
			}
		},
		computed: {
			hasImage(){
				return Object.keys(this.item.images).length
			},
		},
		props: {
			item: {
				type: Object
			},
			flip: {
				type: Boolean,
				default: false
			},
		},
		methods: {
			imageLoaded(instance) {
				this.loaded = true;
			}
		}
  }
</script>



// WEBPACK FOOTER //
// quote-block.vue?6d8aa255